// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogTitle } from '@material-ui/core';

// Internal Dependencies
import MButton from '../../../common/MButton';
import Colours from '../../../../styles/colours';
import MText from '../../../common/MText';
import DeleteContent from './FaqModalDeleteContent';
import SubmitContent from './FaqModalSubmitContent';
import { IsEmpty } from '../../../../common/checks';

const FaqModal = ({
  modal, handleAdd, handleUpdate, handleDelete, handleClose, handleValueUpdate,
}) => {
  const modalSettings = {
    title:              '',
    size:               'md',
    actionButtonColour: Colours.MaterialBlue,
    actionButton:       'Save',
    action:             () => {},
    content:            null,
  };

  if (modal.isDeleting) {
    modalSettings.title = 'Are you sure you want to delete this FAQ?';
    modalSettings.size = 'sm';
    modalSettings.actionButtonColour = Colours.Crimson;
    modalSettings.actionButton = 'Delete';
    modalSettings.action = handleDelete;
    modalSettings.content = <DeleteContent modal={modal} />;
  } else if (!IsEmpty(modal.id)) {
    modalSettings.title = 'Edit FAQ';
    modalSettings.action = handleUpdate;
    modalSettings.content = <SubmitContent modal={modal} handleValueUpdate={handleValueUpdate} />;
  } else {
    modalSettings.title = 'Add FAQ';
    modalSettings.action = handleAdd;
    modalSettings.content = <SubmitContent modal={modal} handleValueUpdate={handleValueUpdate} />;
  }

  return (
    <Dialog open={modal.open} onClose={handleClose} maxWidth={modalSettings.size} fullWidth>
      <DialogTitle>
        <MText bold size={16} colour={Colours.Gray} text={modalSettings.title} />
      </DialogTitle>
      {modalSettings.content}
      <DialogActions>
        <MButton
          textSize={12}
          className="py-2"
          colour={Colours.White}
          textStyle={{ fontWeight: 500 }}
          textColour={Colours.Black}
          onClick={handleClose}
          text="Cancel"
        />
        <MButton
          textSize={12}
          className="py-2"
          colour={modalSettings.actionButtonColour}
          textStyle={{ fontWeight: 500 }}
          textColour={Colours.White}
          onClick={modalSettings.action}
          text={modalSettings.actionButton}
        />
      </DialogActions>
    </Dialog>
  );
};

FaqModal.propTypes = {
  handleAdd:         PropTypes.func.isRequired,
  handleDelete:      PropTypes.func.isRequired,
  handleUpdate:      PropTypes.func.isRequired,
  handleClose:       PropTypes.func.isRequired,
  handleValueUpdate: PropTypes.func.isRequired,
  modal:             PropTypes.shape({
    open:       PropTypes.bool.isRequired,
    qns:        PropTypes.string.isRequired,
    answer:     PropTypes.string.isRequired,
    id:         PropTypes.number,
    isDeleting: PropTypes.bool.isRequired,
  }).isRequired,
};

export default FaqModal;
